import { generatePath } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { FiatBalanceTopUpStepUi } from "@src/widgets/onboarding/ui/tours/AccountTopUp/FiatBalanceTopUpStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class FiatBalanceTopUpStep extends TourStepBase {
  component = FiatBalanceTopUpStepUi
  name = `${ONBOARDING_TOURS.ACCOUNT_TOP_UP}_FiatBalanceTopUpStep`

  constructor() {
    super({ placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT })
  }

  action() {
    return router.navigate({
      pathname: generatePath(paths.depositFiat, {
        network: "fiat",
        symbol: "EUR",
      }),
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Top up with fiat and swap to any cryptocurrency",
      title: "Fiat Balance Top-Up",
    }
  }
}
